/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace f
*/
var f = {};

/**
* @name cdf
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/cdf}
*/
import cdf from './../../../../base/dists/f/cdf';
setReadOnly( f, 'cdf', cdf );

/**
* @name F
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/ctor}
*/
import F from './../../../../base/dists/f/ctor';
setReadOnly( f, 'F', F );

/**
* @name entropy
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/entropy}
*/
import entropy from './../../../../base/dists/f/entropy';
setReadOnly( f, 'entropy', entropy );

/**
* @name kurtosis
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/kurtosis}
*/
import kurtosis from './../../../../base/dists/f/kurtosis';
setReadOnly( f, 'kurtosis', kurtosis );

/**
* @name mean
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/mean}
*/
import mean from './../../../../base/dists/f/mean';
setReadOnly( f, 'mean', mean );

/**
* @name mode
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/mode}
*/
import mode from './../../../../base/dists/f/mode';
setReadOnly( f, 'mode', mode );

/**
* @name pdf
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/pdf}
*/
import pdf from './../../../../base/dists/f/pdf';
setReadOnly( f, 'pdf', pdf );

/**
* @name quantile
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/quantile}
*/
import quantile from './../../../../base/dists/f/quantile';
setReadOnly( f, 'quantile', quantile );

/**
* @name skewness
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/skewness}
*/
import skewness from './../../../../base/dists/f/skewness';
setReadOnly( f, 'skewness', skewness );

/**
* @name stdev
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/stdev}
*/
import stdev from './../../../../base/dists/f/stdev';
setReadOnly( f, 'stdev', stdev );

/**
* @name variance
* @memberof f
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/f/variance}
*/
import variance from './../../../../base/dists/f/variance';
setReadOnly( f, 'variance', variance );


// EXPORTS //

export default f;
